import React, { useState, useEffect, useRef } from "react";
import { db } from "../firebase";
import { collection, query, getDocs } from "firebase/firestore";
import Viewer from './Viewer';
import { Button, Modal } from "react-bootstrap";

const NewsFeed = () => {
  const [newsData, setNewsData] = useState([]);
  const [hovered, setHovered] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      const q = query(collection(db, "News"));
      const querySnapshot = await getDocs(q);

      const news = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setNewsData(news);

      console.log(news);
    };

    fetchData();
  }, []);

  useEffect(() => {
    const container = containerRef.current;
    let animationFrameId;
    let startTime;

    const updateScrollPosition = (timestamp) => {
      if (!startTime) {
        startTime = timestamp;
      }

      const elapsed = timestamp - startTime;
      const duration = 10000; // 10 seconds for full scroll
      const scrollSpeed = 0.5; // pixels per millisecond

      if (container && !hovered) {
        const maxScrollTop = container.scrollHeight - container.clientHeight;
        const newYPosition = (elapsed * scrollSpeed) % (maxScrollTop + container.clientHeight);

        if (newYPosition <= maxScrollTop) {
          container.scrollTop = newYPosition;
        } else {
          // Reset to top for smooth loop
          container.scrollTop = 0;
          startTime = timestamp;
        }

        animationFrameId = requestAnimationFrame(updateScrollPosition);
      }
    };

    if (!hovered && newsData.length > 0) {
      animationFrameId = requestAnimationFrame(updateScrollPosition);
    }

    return () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
    };
  }, [hovered, newsData]);

  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  const [show, setShow] = useState(false);
  const [news, setNews] = useState(null);

  const handleClose = () => {
    setNews(null)
    setShow(false);
  }
  const handleShow = (v) => {
    setNews(v)
    setShow(true);
  }
  return (
    <div className="news-feed-container-parent">
      <h2>News Feed</h2>
      <div
        className="news-feed-container"
        style={{ width: "400px", height: "500px", cursor: "pointer" }}
        ref={containerRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div>
          {newsData.map((news, i) => (
            <div key={i} className="news-item" onClick={() => handleShow(news)}>
              {/* <h4 style={{ fontSize: '1.1rem' }}>{news.field1}</h4> */}
              <div className="">
                <Viewer html={news.field2} />
              </div>
            </div>
          ))}
        </div>
      </div>
      <Modal size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show} onHide={handleClose}>
        {/* <Modal.Header closeButton>
          <Modal.Title>{news?.field1}</Modal.Title>
        </Modal.Header> */}
        <Modal.Body>
          <Viewer html={news?.field2} />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default NewsFeed;
